import * as React from "react";
import { Or } from "source/app/domain/Or";
import { ERPGIcon } from "../../../../../../../motw_core/UI/Icons/ERPGIcon";
import { StyleClass } from "../../Styles/CSS";
import RPGIcon from "../RPGIcon";

export function VerbIcon({
    verbSymbol,
    color,
}: {
    verbSymbol: string;
    color?: string;
}) {
    const icon = GetVerbRPGIcon(verbSymbol);
    const defaultIconColor = GetVerbIconColor(verbSymbol);
    const iconColor = Or(color, defaultIconColor);

    return (
        <RPGIcon
            icon={icon}
            withClass={StyleClass(`VerbIcon_${iconColor}`, {
                color: iconColor,
            })}
            key={ERPGIcon[icon]}
        />
    );
}

function GetVerbRPGIcon(verbSymbol: string) {
    if (verbSymbol === "^") return ERPGIcon.aura;
    if (verbSymbol === "+") return ERPGIcon["monster-skull"];
    if (verbSymbol === "*") return ERPGIcon["jigsaw-piece"];
    if (verbSymbol === "#") return ERPGIcon["hand-emblem"];
    if (verbSymbol === ".") return ERPGIcon["muscle-up"];
    if (verbSymbol === ">") return ERPGIcon["shoe-prints"];
    if (verbSymbol === "<") return ERPGIcon.pyramids;
    if (verbSymbol === "/") return ERPGIcon["castle-flag"];
    if (verbSymbol === "\\") return ERPGIcon["clovers-card"];
    if (verbSymbol === "_") return ERPGIcon["player-pain"];
    return ERPGIcon.help;
}

export function GetVerbIconColor(verbSymbol: string) {
    if (verbSymbol === "^") return "yellow";
    if (verbSymbol === "+") return "lightskyblue";
    if (verbSymbol === "*") return "lightgreen";
    if (verbSymbol === "#") return "lightcoral";
    if (verbSymbol === ".") return "red";
    if (verbSymbol === ">") return "#00b6ff";
    if (verbSymbol === "<") return "#bbff1e";
    if (verbSymbol === "/") return "lightslategray";
    if (verbSymbol === "\\") return "lightseagreen";
    if (verbSymbol === "_") return "#b3a1f7";
    return "white";
}
